import '@ionic/core';
import { Component, Event, EventEmitter, Prop, h } from '@stencil/core';

@Component({
  tag: 'search-palette',
  styleUrl: 'search-palette.css',
  shadow: true
})
export class SearchPalette {
    @Prop() cohortId: number = 0;
    @Prop() searchQuery: string;

    @Event() toggleFilterPalette: EventEmitter;
    @Event() toggleSubscriptionPalette: EventEmitter;
    @Event() updatedSearchQuery: EventEmitter;

    private updateSearchQuery = (e: any) => {
        const newSearchQuery = e.detail ? e.detail.value : null;
        this.updatedSearchQuery.emit(newSearchQuery);
    }

    toggleSubscriptionPanel() {
        this.toggleSubscriptionPalette.emit();
    }

    toggleFilterPanel() {
        this.toggleFilterPalette.emit();
    }

    render() {
        return (
            <div id="SSPBSearchPaletteStage">
                <ion-grid>
                    <ion-row align-items-center>
                        <ion-col>
                        <div>
                            <ion-searchbar type="text" debounce={2000} value={this.searchQuery} placeholder="Search by Location and/or Keyword" onIonInput={this.updateSearchQuery.bind(this)} />
                        </div>
                        </ion-col>
                        <ion-col size="auto">
                        <div>
                            <ion-button fill="clear" onClick={this.toggleSubscriptionPanel.bind(this)}>
                            <ion-icon name="mail-sharp" slot="start" />
                            Notify Me
                            </ion-button>
                        </div>
                        </ion-col>
                        <ion-col size="auto">
                        <div>
                            <ion-button fill="clear" onClick={this.toggleFilterPanel.bind(this)}>
                                <ion-icon name="filter-sharp" slot="start" />
                                Filters
                            </ion-button>
                        </div>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
        );
    }
}
